import React from 'react';
import { Link } from 'react-router-dom';
import dashboardService from '../../services/dashboardService';
import { ROUTES } from '../../constants/routes';

const DashboardActionWorklist = ({ pendingQueue = { snaps: [], reversals: [] } }) => {
  const pendingSnaps = pendingQueue.snaps || [];
  const pendingReversals = pendingQueue.reversals || [];
  const hasItems = pendingSnaps.length > 0 || pendingReversals.length > 0;

  return (
    <div className='bg-white rounded-xl border border-gray-200 shadow-xs p-5 mb-6 transition-all'>
      <div className='flex items-center justify-between mb-4 pb-3 border-b border-gray-100'>
        <div className='flex items-center gap-2'>
          <span className='w-2.5 h-2.5 rounded-full bg-amber-500 animate-ping'></span>
          <h3 className='text-sm font-bold text-gray-900 uppercase tracking-wider'>
            Urgent Action Worklist
          </h3>
        </div>
        <span className='text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-800'>
          {pendingSnaps.length} pending
        </span>
      </div>

      {!hasItems ? (
        <div className='text-center py-6 px-4 bg-emerald-50/60 rounded-lg border border-emerald-100'>
          <div className='w-10 h-10 mx-auto rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mb-2'>
            <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
            </svg>
          </div>
          <h4 className='text-xs font-bold text-emerald-900'>All queues are clear!</h4>
          <p className='text-2xs text-emerald-700 mt-0.5'>There are no pending 1-snaps or reversals awaiting review.</p>
        </div>
      ) : (
        <div className='space-y-3'>
          {/* Pending 1-Snaps */}
          {pendingSnaps.map(snap => (
            <div
              key={snap.id}
              className='p-3 rounded-lg border border-gray-100 bg-gray-50/70 hover:bg-white hover:border-blue-200 hover:shadow-xs transition-all flex flex-col gap-2'
            >
              <div className='flex items-start justify-between gap-2'>
                <div>
                  <div className='text-xs font-bold text-gray-900'>
                    Receipt #{snap.receiptNumber || snap.id.substring(0, 8)}
                  </div>
                  <div className='text-2xs text-gray-500 font-medium'>
                    {snap.merchantName || 'Merchant'} · {dashboardService.formatTimeAgo(snap.createdAt)}
                  </div>
                </div>
                <div className='text-xs font-bold text-gray-900'>
                  {dashboardService.formatCurrency(snap.amount)}
                </div>
              </div>

              <div className='flex items-center justify-end pt-1'>
                <Link
                  to={ROUTES.ONE_SNAP}
                  className='inline-flex items-center gap-1 text-2xs font-bold text-white bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded-md transition-colors shadow-2xs cursor-pointer'
                >
                  Review & Approve →
                </Link>
              </div>
            </div>
          ))}

          {/* Pending Reversals */}
          {pendingReversals.map(rev => (
            <div
              key={rev.id}
              className='p-3 rounded-lg border border-rose-100 bg-rose-50/50 hover:bg-white hover:border-rose-200 hover:shadow-xs transition-all flex items-center justify-between gap-2'
            >
              <div>
                <div className='text-xs font-bold text-rose-900'>
                  Reversal #{rev.cycleCode || rev.id.substring(0, 8)}
                </div>
                <div className='text-2xs text-rose-600 font-medium'>
                  {rev.reason} · {dashboardService.formatTimeAgo(rev.createdAt)}
                </div>
              </div>

              <Link
                to={ROUTES.REVERSAL}
                className='inline-flex items-center gap-1 text-2xs font-bold text-rose-700 bg-rose-100 hover:bg-rose-200 px-2.5 py-1 rounded-md transition-colors'
              >
                Inspect →
              </Link>
            </div>
          ))}

          <div className='pt-2 text-center'>
            <Link
              to={ROUTES.ONE_SNAP}
              className='text-2xs font-semibold text-gray-500 hover:text-blue-600'
            >
              View full verification queue →
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardActionWorklist;
